"use client";
import { motion } from "framer-motion";

export default function AnimateSection({ children }) {
  return (
    <motion.div
      // Opacity-only: a `y` transform still registers as a layout shift in the
      // Layout Instability API even though it's compositor-only, which tanked CLS.
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      viewport={{ once: true, amount: "some" }}
    >
      {children}
    </motion.div>
  );
}
